import React, {useEffect, useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getCustomer, patchUpdateCustomer } from 'redux/actions/UserCustomer';
import Loader from 'components/loader/Loader';
import CommonTable from 'components/commonTable/CommonTable';
import { dateFormate } from 'utils/utils';
import { debounce } from 'lodash';
import CustomerBreadCrumb from './CustomerBreadCrumb';
import { filterdataCustomer } from './CustomerTableData';

function CustomerTable() {
  const customerStatus = JSON.parse(localStorage.getItem('customerStatus'))
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [status, setStatus] = useState(customerStatus?.length > 0 ? customerStatus : "");
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const tableData = useSelector((state) => state?.userCustomer?.userCustomer?.data);
  const loader = useSelector((state) => state?.userCustomer?.loading);
  const [search, setSearch] = useState("")
  let filterData = {
    id:'',
    page:page,
    dateFrom:dateFrom,
    dateTo:dateTo,
    status:status,
    pageSize:rowsPerPage,
    search:search
  }

  useEffect(() => {
    dispatch(getCustomer(filterData));
  }, []);

  const onClickCustomer = (val) => {
    localStorage.setItem('customerStatus', JSON.stringify(status))
    let url = window.location.pathname.split("/")[1]
    if (url === 'customer'){
      navigate(`/customer/detail`, {state: {id: val?.authId, name: val?.name, demandProfileId:val?.id}})
    }
  }
  
  const handleChangePage = (event,newPage) =>{
    setPage(newPage)
    dispatch(getCustomer({...filterData, page:newPage}))
  }

  const handleChangeRowsPerPage = (event) =>{
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    dispatch(getCustomer({...filterData, page:0, pageSize:parseInt(event.target.value)}))
  }

  const onFilterChange = (val) => {
    localStorage.removeItem('customerStatus')
    setPage(0);
    setStatus(val)
    filterData = {...filterData, status:val.toString(), page: 0}
    dispatch(getCustomer(filterData));
  }

  const onRestFilter = () => {
    localStorage.removeItem('customerStatus')
    setStatus("")
    filterData = {...filterData, status:""}
    dispatch(getCustomer(filterData));
  }

  const onSelectDateRange = (newValue) => {
    setDateFrom(dateFormate(newValue[0]).format("MM/DD/YYYY"))
    setDateTo(dateFormate(newValue[1]).format("MM/DD/YYYY"))
    filterData = {...filterData, 
      dateFrom:dateFormate(newValue[0]).format("MM/DD/YYYY"),
      dateTo:dateFormate(newValue[1]).format("MM/DD/YYYY")
    }
    dispatch(getCustomer(filterData));
  }

  const onSearch = debounce((e) =>{
    setSearch(e);
    setPage(0);
   filterData = {...filterData, search:e, page: 0}

    dispatch(getCustomer(filterData))
  },1000)

  const onClickMoreIcon = (data, iconType) => {
    if (iconType === 'Activate') {
      const profileData = {
        customerId: data.id,
        data: {
          status: 'Active',
          page:page,
          rowsPerPage:rowsPerPage
        },
      };
      dispatch(patchUpdateCustomer(profileData));
    } else if (iconType === 'Block') {
      const profileData = {
        customerId: data.id,
        data: {
          status: 'Blocked',
          page:page,
          rowsPerPage:rowsPerPage
        },
      };
      dispatch(patchUpdateCustomer(profileData));
    } else if (iconType === 'Unblock') {
      const profileData = {
        customerId: data.id,
        data: {
          status: 'Active',
          page:page,
          rowsPerPage:rowsPerPage
        },
      };
      dispatch(patchUpdateCustomer(profileData));
    }
  };
  


  return (
    <div>
        <CustomerBreadCrumb 
          defaultStatus={status}
          filterdata={filterdataCustomer} 
          onFilterChange={onFilterChange}
          onRestFilter={onRestFilter}
          onSelectDateRange={onSelectDateRange}
          onSearch = {onSearch}
        />
        {loader? 
        <Loader/> 
        :
        <CommonTable 
          data={tableData} 
          onClickTableVendor={onClickCustomer}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          page={page}
          rowsPerPage={rowsPerPage}
          tabName={'customer'}
          onClickMoreIcon={onClickMoreIcon}
          isClickable = {true}

        />
        }
    </div>
  )
}

export default CustomerTable